export default "__VITE_ASSET__a3790f25__"